import { render, staticRenderFns } from "./ApexPieChart.vue?vue&type=template&id=1771a274&scoped=true&"
import script from "./ApexPieChart.vue?vue&type=script&lang=js&"
export * from "./ApexPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexPieChart.vue?vue&type=style&index=0&id=1771a274&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1771a274",
  null
  
)

export default component.exports